import * as React from "react";
import { Button } from "@/taskpane/components/ui/button";
import { ArrowLeft } from "lucide-react";

interface OnboardingHeaderProps {
  onBack?: () => void;
}

const OnboardingHeader: React.FC<OnboardingHeaderProps> = ({ onBack }) => {
  return (
    <div className="flex flex-col gap-4 w-full">
      <div className="flex justify-between items-center w-full">
        <div className="flex-1 flex justify-start">
          {onBack && (
            <Button
              variant="ghost"
              size="icon"
              className="w-5 h-5"
              aria-label="Back"
              onClick={onBack}
            >
              <ArrowLeft size={20} />
            </Button>
          )}
        </div>
        <div className="flex items-center justify-center">
          <img
            src="assets/aila-logo-updated.png"
            alt="AI Legal Assistant Logo"
            width="92"
            height="34"
          />
        </div>
        <div className="flex-1" />
      </div>
      <div className="h-px bg-border w-full" />
    </div>
  );
};

export default OnboardingHeader;
